import {
  Box,
  Card,
  Divider,
  Grid,
  Grid2,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import assetconfig from "../../config/assestsConfig";

const PayslipLayout = ({
  payslipRef,
  selectedYear,
  selectedMonth,
  Userdetails,
  totaldata,
  Earning,
  Deductions,
  totalAmount,
  amountInWords,
  totalMonthly,
  totalYearly,
  totalYTD,
  totalEarYtd,
  totalEarActuals,
}) => {
  const logo = assetconfig?.logo;
  const companyname = assetconfig?.actualname;

  return (
    <Card sx={{ marginTop: 3, boxShadow: 2 }}>
      <Grid2
        container
        spacing={2}
        size={12}
        sx={{
          margin: "20px",
          padding: { xs: "10px", md: "20px" },
          fontSize: "14px",
        }}
        ref={payslipRef}
      >
        <Grid2 container size={12} xs={12} md={12}>
          <Grid2 size={6} display={"flex"} flexDirection={"column"} xs={6}>
            <header style={{ fontSize: "24px", fontWeight: "bold" }}>
              {companyname}
            </header>
            <Typography variant="body2">CHENNAI,</Typography>
            <Typography variant="body2">TAMILNADU 600035</Typography>
          </Grid2>

          <Grid2
            item
            xs={6}
            display={"flex"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            sx={{ width: { lg: "30%" } }}
          >
            <img
              src={logo}
              alt="logo"
              style={{ maxWidth: "200px", height: "auto" }}
            />
          </Grid2>

          <Grid2 sx={{ marginLeft: "-2%" }} size={12}>
            <Divider
              sx={{
                height: 3,
                backgroundColor: "#3F51B5d4",
                marginY: 2,
              }}
            />
          </Grid2>
        </Grid2>

        {/* Payslip Title */}
        <Grid2
          container
          justifyContent="center"
          sx={{ marginBottom: 1 }}
          size={{ xs: 12, md: 12, lg: 6 }}
          spacing={1}
        >
          <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
            {/* Payslip Header */}
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                textAlign: "left",
                marginBottom: 1,
              }}
            >
              {` Payslip for the month of ${selectedMonth} ${selectedYear}`}
            </Typography>

            {/* Employee Pay Summary */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                textAlign: "left",
                marginBottom: 0,
                color: "darkslategray",
                fontSize: "18px",
              }}
            >
              Employee Pay Summary
            </Typography>

            {/* Pay Details */}
            <List
              sx={{
                width: "100%",
                maxWidth: "600px",
                borderRadius: "8px",
                padding: "5px 0 0 0",
              }}
            >
              <ListItem
                sx={{
                  display: "grid",
                  gridTemplateColumns: "150px auto",
                  gap: 1.5,
                  alignItems: "center",
                  padding: "12px 0 0 0",
                }}
              >
                {/* EMPLOYEE NAME */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", color: "#abb2b9" }}
                >
                  EMPLOYEE NAME
                </Typography>
                <Typography variant="body2" sx={{ color: "#333 " }}>
                  {Userdetails.firstName?.toUpperCase()}
                </Typography>

                {/* DESIGNATION */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", color: "#abb2b9" }}
                >
                  DESIGNATION
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  {Userdetails.designation?.toUpperCase()}
                </Typography>

                {/* DATE OF JOINING */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", color: "#abb2b9" }}
                >
                  DATE OF JOINING
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  {(() => {
                    const date = new Date(Userdetails.dateJoined);
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
                    const year = date.getFullYear();
                    return `${day}/${month}/${year}`;
                  })()}
                </Typography>

                {/* PAY DATE */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", color: "#abb2b9" }}
                >
                  PAY DATE
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  {`${selectedMonth} ${selectedYear}`}
                </Typography>

                {/* PAY PERIOD */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", color: "#abb2b9" }}
                >
                  PAY PERIOD
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  PERIOD
                </Typography>

                {/* UAN NUMBER */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", color: "#abb2b9" }}
                >
                  UAN NUMBER
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  {Userdetails.uanNumber}
                </Typography>

                {/* ESI NUMBER */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", color: "#abb2b9" }}
                >
                  ESI NUMBER
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  {Userdetails.esicNumber}
                </Typography>
              </ListItem>
              <Divider />
            </List>
          </Grid2>
        </Grid2>

        {/* Employee Net Pay Section */}
        <Grid2
          size={{ xs: 12, md: 12, lg: 6 }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              padding: "16px 73px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              backgroundColor: "#ffffff",
              textAlign: "center",
              marginBottom: "18%",
              // boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            }}
          >
            {/* Employee Net Pay Title */}
            <Typography
              variant="body1"
              sx={{
                color: "#777",
                fontWeight: "500",
                marginBottom: "8px",
              }}
            >
              Employee Net Pay
            </Typography>

            {/* Net Pay Amount */}
            <Typography
              variant="h5"
              sx={{
                color: "#27ae60",
                fontWeight: "bold",
                fontSize: "1.8rem",
                marginBottom: "8px",
              }}
            >
              {totaldata?.netPay}
            </Typography>

            {/* Paid Days and LOP Days */}
            <Typography
              variant="body2"
              sx={{
                color: "#777",
                fontWeight: "400",
                fontSize: "0.9rem",
              }}
            >
              LOP Count : <strong>{totaldata?.lossOfPayCount}</strong>
            </Typography>
          </Box>
        </Grid2>

        
        <Typography variant="h5" fontWeight={600}>Salary Breakdown (₹) </Typography>
        

        {/* Earnings & Deductions Tables */}
        <Grid2 container spacing={3} size={12} sx={{ width: "100%", marginTop: 0 }}>

          {/* Earnings Table */}
          {totaldata?.gross !== null && (
            <Grid2 size={{ xs: 12, md: 6 }}>
              <table style={{ borderCollapse: "collapse", width: "100%" }}>
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#f0f0f0",
                      fontWeight: "bold",
                    }}
                  >
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px 12px",
                        textAlign: "left",
                      }}
                    >
                      Earnings
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px 12px",
                        textAlign: "right",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Earning.map((earning, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                        fontSize: "14px",
                      }}
                    >
                      <td
                        style={{
                          padding: "8px 12px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        {earning?.componentName}
                      </td>
                      <td
                        style={{
                          padding: "8px 12px",
                          border: "1px solid #ddd",
                          textAlign: "right",
                        }}
                      >
                        {earning?.monthly}
                      </td>
                    </tr>
                  ))}
                  {/* GROSS EARNINGS ROW */}
                  <tr
                    style={{
                      fontWeight: "bold",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px 12px",
                        border: "1px solid #ddd",
                        textAlign: "left",
                      }}
                    >
                      Gross Earnings
                    </td>
                    <td
                      style={{
                        padding: "10px 12px",
                        border: "1px solid #ddd",
                        textAlign: "right",
                      }}
                    >
                      {totalMonthly.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid2>
          )}

          {/* Deductions Table */}
          <Grid2 size={{ xs: 12, md: totaldata?.gross !== null ? 6 : 12 }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "left",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#f0f0f0",
                    fontWeight: "bold",
                  }}
                >
                  <th
                    style={{
                      padding: "10px 12px",
                      border: "1px solid #ddd",
                      textAlign: "left",
                    }}
                  >
                    Deductions
                  </th>
                  <th
                    style={{
                      padding: "10px 12px",
                      border: "1px solid #ddd",
                      textAlign: "right",
                    }}
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Display Deductions */}
                {Deductions.map((deduction, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                      fontSize: "14px",
                    }}
                  >
                    <td
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ddd",
                        textAlign: "left",
                      }}
                    >
                      {deduction?.componentName}
                    </td>
                    <td
                      style={{
                        padding: "8px 12px",
                        border: "1px solid #ddd",
                        textAlign: "right",
                      }}
                    >                      
                      {deduction?.monthly}
                    </td>
                  </tr>
                ))}
                {/* Display Gross Deductions */}
                <tr
                  style={{
                    backgroundColor: "#f0f0f0",
                    fontWeight: "bold",
                  }}
                >
                  <td
                    style={{
                      padding: "10px 12px",
                      border: "1px solid #ddd",
                      textAlign: "left",
                    }}
                  >
                    Gross Deductions
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      border: "1px solid #ddd",
                      textAlign: "right",
                    }}
                  >
                    {totalAmount.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </Grid2>
        </Grid2>

        {/* Total Net Payable Section */}
        <Grid2 size={12}>
          <div
            style={{
              width: "100%",
              height: "60px",
              backgroundColor: "#45a049",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              margin: "20px 0",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "600",
              padding: "5px 15px",
              textTransform: "uppercase",
              transition: "background-color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#45a049")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#4CAF50")}
          >
            {`Total Net Payable: ₹${totaldata?.netPay} (${
              amountInWords.charAt(0).toUpperCase() + amountInWords.slice(1)
            })`}
          </div>
        </Grid2>

        <Grid2 sx={{ marginLeft: "-2%" }} size={12}>
          <Divider
            sx={{ height: 3, backgroundColor: "#3F51B5d4", marginY: 2 }}
          />
        </Grid2>

        {/* Download PDF Button */}
      </Grid2>
    </Card>
  );
};

export default PayslipLayout;
